import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { getBrokerList, brokerConfigrationModalAction } from '../../../redux/actions/brokerAction';
import { fetchUserStaticIPsAction } from "../../../redux/actions/packageAction";
import BrokerService from "../../../services/broker.service";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Collapse, Tag, Switch } from 'antd';
import zerodhaDevLoginImg from 'assets/img/zerodha-configration/login.png';
import kiteAppCreateImg from 'assets/img/zerodha-configration/Developer-kite-App-create-steps.jpg';
import AppSelectionImg from 'assets/img/zerodha-configration/AppSelection.jpg';
import AppSecrateKeyImg from 'assets/img/zerodha-configration/API_Secret_Key.jpg';
import AppTOTPSecrateKeyImg from 'assets/img/zerodha-configration/TOTP_Secret_Key.jpg';
import icicidirect1 from 'assets/img/icici/icici-direct-1.png';
import icicidirect2 from 'assets/img/icici/icici-direct-2.png';
import icicidirect3 from 'assets/img/icici/icici-direct-3.png';
import icicidirect4 from 'assets/img/icici/icici-direct-4.png';
import icicidirect5 from 'assets/img/icici/icici-direct-5.png';
import icicidirect6 from 'assets/img/icici/icici-direct-6.png';
import icicidirect8 from 'assets/img/icici/icici-direct-8.png';
import upstox1 from 'assets/img/upstox/upstox1.png';
import upstox2 from 'assets/img/upstox/upstox2.png';
import upstox3 from 'assets/img/upstox/upstox3.png';
import upstox4 from 'assets/img/upstox/upstox4.png';
import FlatTrade1 from 'assets/img/FlatTrade/FlatTrade1.png';
import FlatTrade2 from 'assets/img/FlatTrade/FlatTrade2.png';
import FlatTrade3 from 'assets/img/FlatTrade/FlatTrade3.png';
import FlatTrade4 from 'assets/img/FlatTrade/FlatTrade4.png';
import FlatTrade5 from 'assets/img/FlatTrade/FlatTrade5.png';
import Shoonya1 from 'assets/img/Shoonya/Shoonya1.png';
import Shoonya2 from 'assets/img/Shoonya/Shoonya2.png';
import zebu1 from 'assets/img/zebu/zebu1.png';
import zebu2 from 'assets/img/zebu/zebu2.png';
import zebu3 from 'assets/img/zebu/zebu3.png';
import zebu4 from 'assets/img/zebu/zebu4.png';
import zebu5 from 'assets/img/zebu/zebu5.png';
import zebu6 from 'assets/img/zebu/zebu6.png';
import { Base64 } from 'js-base64';
import SearchDropDown from "../../../ui-components/SearchDropDown";
import { Height } from "@mui/icons-material";
import { useToast } from "components/common/custom-toast/Toast";
import { Copy } from "lucide-react";
const { Panel } = Collapse;

const BrokerSetup = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const toast = useToast()

    const tradeApiUrl = process.env.REACT_APP_API_URL_LOGIN;

    const [state, setState] = useState({
        hideShowText: true,
        brokerAccount: {
            id: "",
            status: "",
            name: '',
            type: "zerodha",
            brokerSubType: "",
            autoLogin: false,
            userName: "",
            password: "",
            apiKey: "",
            secret: "",
            totpSecret: "",
            apiToken: "",
            tokenCreationTime: "",
            autoLoginDisabled: true,
            clientIdforDealer: "",
            mpin: "",
            phoneNumber: "",
            XtsBrokerName: "",
            XtsBaseUrl: "",
            XtsTotpNeeded: false,
            vendorUserId: "",
            purpose: "terminal"
        },
        defaultActiveKey: 1,
        copySuccess: 'Copy URL',
        showPassword: false,
        brokerNotList: false,
        userIps: [],
        fetchingIps: false
    });

    useEffect(() => {
        const fetchIps = async () => {
            setState(prev => ({ ...prev, fetchingIps: true }));
            const data = await dispatch(fetchUserStaticIPsAction());
            if (data && data.ips) {
                setState(prev => ({
                    ...prev,
                    userIps: data.ips.filter(ip => ip.status === 'active'),
                    fetchingIps: false
                }));
            } else {
                setState(prev => ({ ...prev, fetchingIps: false }));
            }
        };
        fetchIps();
    }, [dispatch]);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            brokerAccount: {
                ...prevState.brokerAccount,
                type: location?.state?.type || "zerodha",
                userName: location?.state?.userName || "",
                brokerSubType: location?.state?.type === 'xtsRetail' ? "" : (location?.state?.loginTypeSubType === "jainam" ? 'A' :
                    location?.state?.loginTypeSubType === "acagarwal" ? 'AC Agarwal' :
                        location?.state?.loginTypeSubType),
            },
            brokerNotList: location?.state?.type === 'xtsRetail',
            defaultActiveKey: location?.state?.type === 'icici' ? 4 : 2
        }));
        console.log("FROM-Received", location);
    }, [location]);

    const handleCopy = (text, message = 'Copied!') => {
        navigator.clipboard.writeText(text).then(() => {
            toast.success(message);
        }).catch(() => {
            toast.error('Unable to copy');
        });
    };

    const hideShowtextEvent = () => {
        setState(prev => ({ ...prev, showPassword: !prev.showPassword }));
    };

    const onChange = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === 'checkbox' ? checked : name === 'userName' ? value.toUpperCase() : value;

        setState(prev => ({
            ...prev,
            brokerAccount: {
                ...prev.brokerAccount,
                [name]: newValue
            },
            defaultActiveKey: (name === 'apiKey' || name === 'secret') && prev.brokerAccount.type === "icici" ? "8" :
                (name === 'apiKey' || name === 'secret') && prev.brokerAccount.type === "zerodha" ? "6" :
                    name === 'userName' && ["zerodha", "icici", "upstox", "flattrade", "shoonya", "zebu"].includes(prev.brokerAccount.type) ? "2" :
                        prev.defaultActiveKey
        }));
        console.log('ChangeAfter', state.brokerAccount);
    };

    const onChangeBrokerType = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            brokerAccount: {
                ...prev.brokerAccount,
                [name]: value
            },
            defaultActiveKey: value === "icici" ? "2" : "1"
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setState(prev => ({ ...prev, loading: true }));

        const { brokerAccount } = state;
        let brokerAddParma = {};

        if (["zerodha", "shoonya", "firstock", "5paisa", "angelone", "aliceblue"].includes(brokerAccount.type)) {
            brokerAddParma = {
                name: brokerAccount.name,
                type: brokerAccount.type === "angelone" ? "angelone" : brokerAccount.type,
                autoLogin: brokerAccount.autoLogin,
                loginType: 'apikey',
                purpose: brokerAccount.purpose,
                configuration: {
                    userName: brokerAccount.userName,
                    password: brokerAccount.password,
                    apiKey: brokerAccount.apiKey,
                    secret: brokerAccount.secret,
                    totpSecret: brokerAccount.totpSecret || "",
                    mpin: brokerAccount.mpin || "",
                    vendorUserId: brokerAccount.vendorUserId || "",
                    basketOrderPriority: ["SELL", "BUY"]
                }
            };
        } else if (brokerAccount.type === "xtsProp") {
            brokerAddParma = {
                name: brokerAccount.name,
                type: 'xts',
                autoLogin: brokerAccount.autoLogin,
                loginType: 'apikey',
                purpose: brokerAccount.purpose,
                configuration: {
                    brokerSubType: brokerAccount.brokerSubType === "A" ? "jainam" : brokerAccount.brokerSubType,
                    userName: brokerAccount.userName,
                    apiKey: brokerAccount.apiKey,
                    secret: brokerAccount.secret,
                    xtsClientId: brokerAccount.userName
                }
            };
        } else if (brokerAccount.type === "xtsRetail") {
            brokerAddParma = {
                name: brokerAccount.name,
                type: 'xts',
                autoLogin: brokerAccount.autoLogin,
                loginType: 'apikey',
                purpose: brokerAccount.purpose,
                configuration: {
                    brokerSubType: brokerAccount.brokerSubType === "AC Agarwal" ? 'acagarwal' : brokerAccount.brokerSubType,
                    userName: brokerAccount.userName,
                    apiKey: brokerAccount.apiKey,
                    secret: brokerAccount.secret,
                    XtsBrokerName: brokerAccount.XtsBrokerName,
                    XtsBaseUrl: brokerAccount.XtsBaseUrl,
                    XtsTotpNeeded: brokerAccount.XtsTotpNeeded
                }
            };
        } else if (brokerAccount.type === "kotakneo") {
            brokerAddParma = {
                name: brokerAccount.name,
                type: brokerAccount.type,
                autoLogin: brokerAccount.autoLogin,
                loginType: 'apikey',
                purpose: brokerAccount.purpose,
                configuration: {
                    userName: brokerAccount.userName,
                    password: "",
                    apiKey: brokerAccount.apiKey,
                    phoneNumber: brokerAccount.phoneNumber,
                    mpin: brokerAccount.mpin,
                }
            };
        } else if (brokerAccount.type === "zebu") {
            brokerAddParma = {
                name: brokerAccount.name,
                type: brokerAccount.type,
                autoLogin: brokerAccount.autoLogin,
                loginType: 'apikey',
                purpose: brokerAccount.purpose,
                configuration: {
                    userName: brokerAccount.userName,
                    apiKey: brokerAccount.apiKey,
                }
            };
        } else {
            brokerAddParma = {
                name: brokerAccount.name,
                type: brokerAccount.type,
                autoLogin: brokerAccount.autoLogin,
                loginType: 'apikey',
                purpose: brokerAccount.purpose,
                configuration: {
                    userName: brokerAccount.userName,
                    apiKey: brokerAccount.apiKey,
                    secret: brokerAccount.secret,
                }
            };
        }

        BrokerService.addBroker(brokerAddParma).then(
            response => {
                if (response.code === 200) {
                    dispatch(getBrokerList('loggedIn'));
                    navigate('/broker-login');
                    toast.success('Broker Account Added.');
                } else if (response.code === 400) {
                    toast.error(response.error);
                } else {
                    toast.error('Please fill required fields.');
                }
                setState(prev => ({ ...prev, loading: false }));
            },
            error => {
                setState(prev => ({
                    ...prev,
                    content: (error.response && error.response.data) || error.message || error.toString(),
                    loading: false
                }));
            }
        );
    };

    const brokerReloadAction = (row) => {
        dispatch({ type: 'GET_BROKER_ACCOUNTS', payload: row });
    };

    const onTabChange = (key) => {
        setState(prev => ({ ...prev, defaultActiveKey: key }));
    };

    const onChangextsType = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            brokerAccount: {
                ...prev.brokerAccount,
                [name]: value,
                brokerSubType: value === 'xtsRetail' ? "" : prev.brokerAccount.brokerSubType
            },
            brokerNotList: value === 'xtsRetail'
        }));
    };

    const onChangeBrokerxtsType = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            brokerAccount: {
                ...prev.brokerAccount,
                [name]: value
            }
        }));
    };

    const brokerNotInList = () => {
        setState(prev => {
            const newBrokerNotList = !prev.brokerNotList;
            return {
                ...prev,
                brokerNotList: newBrokerNotList,
                brokerAccount: {
                    ...prev.brokerAccount,
                    brokerSubType: newBrokerNotList ? "" :
                        props?.location?.state?.loginTypeSubType === "jainam" ? 'A' :
                            props?.location?.state?.loginTypeSubType === "acagarwal" ? 'AC Agarwal' :
                                props?.location?.state?.loginTypeSubType,
                    XtsBrokerName: "",
                    XtsBaseUrl: ""
                }
            };
        });
    };


    const { brokerAccount, defaultActiveKey, copySuccess, showPassword, brokerNotList, userIps } = state;

    const isSaveDisabled = () => {
        const { name, userName, apiKey, secret, type, phoneNumber, mpin, password, vendorUserId } = brokerAccount;

        if (!name || !userName || !apiKey) {
            return true;
        }

        if (type === 'kotakneo') {
            return !(phoneNumber && mpin);
        }

        if (type === 'shoonya' || type === 'firstock' || type === '5paisa' || type === 'angelone' || type === 'aliceblue') {
            const hasBasic = name && userName && apiKey && secret;
            if (type === '5paisa') return !hasBasic || !vendorUserId;
            if (type === 'angelone') return !hasBasic || !mpin;
            return !hasBasic;
        }

        if (type === 'zebu') {
            return false;
        }

        return !secret;
    }

    return (
        <>
            <Row className="">
                <Col md={4}>
                    <div className="broker-config-form card pb-2">
                        <div className="card-body">
                            <Form onSubmit={onSubmit} autoComplete="off">
                                <Row className="mb-3">
                                    {(brokerAccount.type === 'xtsRetail' || brokerAccount.type === 'xtsProp') && (
                                        <Col md={6}>
                                            <Form.Group className="form-row">
                                                <Form.Label className="text-black mb-2">Type</Form.Label>
                                                <Form.Select className="form-select-broker" name="type" value={brokerAccount.type} onChange={onChangextsType}>
                                                    <option value="xts">{brokerAccount.type === 'xtsRetail' ? 'Open XTS' : 'Jainam XTS'}</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    )}
                                    {brokerAccount.type === 'xtsProp' && (
                                        <Col md={6} style={{ paddingLeft: "12px" }}>
                                            <Form.Group className="mb-2 form-row">
                                                <Form.Label className="text-black mb-2">Server</Form.Label>
                                                <SearchDropDown
                                                    options={['A', 'B', 'C']}
                                                    width={"100%"}
                                                    height={36}
                                                    notFoundText="Instrument Not Found !"
                                                    onChange={(val) => {
                                                        setState(prev => ({
                                                            ...prev,
                                                            brokerAccount: {
                                                                ...prev.brokerAccount,
                                                                brokerSubType: val === "A" ? "jainam" : val === "B" ? "jainamb" : 'jainamc'
                                                            }
                                                        }));
                                                    }}
                                                    size="middle"
                                                    defaultValue={brokerAccount.brokerSubType}
                                                    valueId="brokerSubType"
                                                />
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                                {(brokerAccount.type !== 'xtsRetail' && brokerAccount.type !== 'xtsProp') && (
                                    <Form.Group className="mb-3 form-row">
                                        <Form.Label className="text-black">Broker</Form.Label>
                                        <Form.Select className="form-select-broker" name="type" value={brokerAccount.type} onChange={onChangeBrokerType}>
                                            <option value="zerodha">Zerodha</option>
                                            {/* <option value="icici">ICICI Direct</option> */}
                                            <option value="flattrade">FlatTrade</option>
                                            <option value="upstox">Upstox</option>
                                            <option value="shoonya">Shoonya</option>
                                            <option value="kotakneo">Kotak Neo</option>
                                            <option value="zebu">Zebu</option>
                                            <option value="dhan">Dhan</option>
                                            <option value="fyers">Fyers</option>
                                            <option value="firstock">Firstock</option>
                                            <option value="5paisa">5paisa</option>
                                            <option value="angelone">AngelOne</option>
                                            <option value="aliceblue">Aliceblue</option>
                                            <option value="arrow">Arrow</option>
                                            <option value="groww">Groww</option>
                                        </Form.Select>
                                    </Form.Group>
                                )}
                                <Form.Group className="mb-3 form-row">
                                    <Form.Label className="text-black mb-2">Name of the API Connection<span className="text-danger">*</span></Form.Label>
                                    <Form.Control className="form-control-broker" type="text" placeholder="Option Selling Account" name="name" value={brokerAccount.name} onChange={onChange} />
                                    {brokerAccount.name && <i className="fa-solid fa-circle-check"></i>}
                                </Form.Group>
                                <Form.Group className="mb-3 form-row">
                                    <Form.Label className="text-black mb-2">Account Assignment<span className="text-danger">*</span></Form.Label>
                                    <div className="broker-purpose-radio-group">
                                        <label className={`broker-purpose-radio-option ${brokerAccount.purpose === 'terminal' ? 'selected' : ''}`}>
                                            <input type="radio" name="purpose" value="terminal" checked={brokerAccount.purpose === 'terminal'} onChange={onChange} />
                                            <span className="broker-purpose-radio-label">Terminal</span>
                                            <span className="broker-purpose-radio-desc">Manual trading from QuikTrade</span>
                                        </label>
                                        <label className={`broker-purpose-radio-option ${brokerAccount.purpose === 'algo' ? 'selected' : ''}`}>
                                            <input type="radio" name="purpose" value="algo" checked={brokerAccount.purpose === 'algo'} onChange={onChange} />
                                            <span className="broker-purpose-radio-label">Algo</span>
                                            <span className="broker-purpose-radio-desc">Run strategies on this account</span>
                                        </label>
                                    </div>
                                </Form.Group>
                                {brokerAccount.type === 'xtsRetail' && brokerNotList && (
                                    <>
                                        <Form.Group className="mb-3 form-row">
                                            <Form.Label className="text-black">Broker Name<span className="text-danger">*</span></Form.Label>
                                            <Form.Control className="form-control-broker" type="text" placeholder="Broker Name" name="XtsBrokerName" value={brokerAccount.XtsBrokerName} onChange={onChange} />
                                            {brokerAccount.XtsBrokerName && <i className="fa-solid fa-circle-check"></i>}
                                        </Form.Group>
                                        <Form.Group className="mb-3 form-row">
                                            <Form.Label className="text-black">Dashboard URL<span className="text-danger">*</span></Form.Label>
                                            <Form.Control className="form-control-broker" type="text" placeholder="Base URL" name="XtsBaseUrl" value={brokerAccount.XtsBaseUrl} onChange={onChange} />
                                            {brokerAccount.XtsBaseUrl && <i className="fa-solid fa-circle-check"></i>}
                                        </Form.Group>
                                    </>
                                )}
                                <div className={brokerNotList ? "d-flex" : ""}>
                                    <Form.Group className="mb-3 form-row">
                                        <Form.Label className="text-black mb-2">
                                            {brokerAccount.type === 'zerodha' ? 'Zerodha Client ID' :
                                                brokerAccount.type === 'icici' ? 'ICICI User ID' :
                                                    brokerAccount.type === 'flattrade' ? 'FlatTrade Client ID' :
                                                        brokerAccount.type === 'upstox' ? 'Upstox Client ID' :
                                                            brokerAccount.type === 'shoonya' ? "Shoonya Client ID" :
                                                                brokerAccount.type === 'zebu' ? "Zebu Client ID" :
                                                                    brokerAccount.type === 'dhan' ? "Dhan Client ID" :
                                                                        brokerAccount.type === 'fyers' ? "Fyers Client ID" :
                                                                            brokerAccount.type === 'firstock' ? "Firstock Client ID" :
                                                                                brokerAccount.type === '5paisa' ? "5paisa User ID" :
                                                                                    brokerAccount.type === 'angelone' ? "AngelOne User ID" :
                                                                                        brokerAccount.type === 'aliceblue' ? "Aliceblue Client ID" :
                                                                                            brokerAccount.type === 'xtsRetail' || brokerAccount.type === 'xtsProp' ? "Client ID" :
                                                                                                brokerAccount.type === 'kotakneo' ? "Kotak Neo User Name" :
                                                                                                    brokerAccount.type === 'arrow' ? "Arrow User Name" :
                                                                                                        brokerAccount.type === 'groww' ? "Groww User Name" : ""} <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control className="form-control-broker" type="text" placeholder={brokerAccount.type === 'zerodha' ? 'Zerodha Client ID' :
                                            brokerAccount.type === 'icici' ? 'ICICI User ID' :
                                                brokerAccount.type === 'flattrade' ? 'FlatTrade Client ID' :
                                                    brokerAccount.type === 'upstox' ? 'Upstox Client ID' :
                                                        brokerAccount.type === 'shoonya' ? "Shoonya Client ID" :
                                                            brokerAccount.type === 'zebu' ? "Zebu Client ID" :
                                                                brokerAccount.type === 'dhan' ? "Dhan Client ID" :
                                                                    brokerAccount.type === 'fyers' ? "Fyers Client ID" :
                                                                        brokerAccount.type === 'firstock' ? "Firstock Client ID" :
                                                                            brokerAccount.type === '5paisa' ? "5paisa User ID" :
                                                                                brokerAccount.type === 'angelone' ? "AngelOne User ID" :
                                                                                    brokerAccount.type === 'aliceblue' ? "Aliceblue Client ID" :
                                                                                        (brokerAccount.type === 'xtsRetail' || brokerAccount.type === 'xtsProp') ? "Client ID" : ""}
                                            name="userName" value={brokerAccount.userName} onChange={onChange} autoSuggest="off" />
                                        {brokerAccount.userName && <i className="fa-solid fa-circle-check"></i>}
                                    </Form.Group>
                                    {brokerAccount.type === 'xtsRetail' && brokerNotList && (
                                        <Form.Group className="mb-3 ms-5 form-row display-flex">
                                            <Form.Label className="text-black">TOTP Required</Form.Label>
                                            <div className="mt-1">
                                                <Switch
                                                    checkedChildren="Yes"
                                                    unCheckedChildren="No"
                                                    checked={brokerAccount.XtsTotpNeeded}
                                                    onChange={(checked) => {
                                                        setState(prev => ({
                                                            ...prev,
                                                            brokerAccount: {
                                                                ...prev.brokerAccount,
                                                                XtsTotpNeeded: checked
                                                            }
                                                        }));
                                                    }}
                                                />
                                            </div>
                                        </Form.Group>
                                    )}
                                </div>
                                {brokerAccount.type === 'shoonya' && (
                                    <Form.Group className="mb-3 form-row" controlId="secret">
                                        <Form.Label className="text-black">Vendor Code<span className="text-danger">*</span></Form.Label>
                                        <Form.Control className="form-control-broker" type="text" placeholder="Vendor Code" name="secret" value={brokerAccount.secret} onChange={onChange} />
                                        {brokerAccount.secret && <i className="fa-solid fa-circle-check"></i>}
                                    </Form.Group>
                                )}
                                <Form.Group className="mb-3 form-row" controlId="apiKey">
                                    <Form.Label className="text-black mb-2">
                                        {(brokerAccount.type === 'xtsRetail' || brokerAccount.type === 'xtsProp') ? 'Interactive Order API Key' : "API Key"} <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control className="form-control-broker" type="text" placeholder="API Key" name="apiKey" value={brokerAccount.apiKey} onChange={onChange} />
                                    {brokerAccount.apiKey && <i className="fa-solid fa-circle-check"></i>}
                                </Form.Group>
                                {brokerAccount.type === '5paisa' && (
                                    <Form.Group className="mb-3 form-row" controlId="vendorUserId">
                                        <Form.Label className="text-black">Vendor User ID<span className="text-danger">*</span></Form.Label>
                                        <Form.Control className="form-control-broker" type="text" placeholder="Vendor User ID" name="vendorUserId" value={brokerAccount.vendorUserId} onChange={onChange} />
                                        {brokerAccount.vendorUserId && <i className="fa-solid fa-circle-check"></i>}
                                    </Form.Group>
                                )}
                                {(brokerAccount.type === 'shoonya' || brokerAccount.type === 'firstock') && (
                                    <Form.Group className="mb-3 form-row passwordInputWrap">
                                        <Form.Label className="text-black">Password</Form.Label>
                                        <Form.Control className="form-control-broker" type={showPassword ? "text" : "password"} placeholder="Password" name="password" value={brokerAccount.password} onChange={onChange} autoComplete="new-password" />
                                        <div className="password-icon" onClick={hideShowtextEvent}>
                                            {showPassword ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}
                                        </div>
                                    </Form.Group>
                                )}
                                {(brokerAccount.type !== 'shoonya' && brokerAccount.type !== 'kotakneo' && brokerAccount.type !== 'zebu') && (
                                    <Form.Group className="mb-3 form-row" controlId="secret">
                                        <Form.Label className="text-black mb-2">
                                            {(brokerAccount.type === 'xtsRetail' || brokerAccount.type === 'xtsProp') ? 'Interactive Order API Secret' : "API Secret"}<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control className="form-control-broker" type="text" placeholder="API Secret" name="secret" value={brokerAccount.secret} onChange={onChange} />
                                        {brokerAccount.secret && <i className="fa-solid fa-circle-check"></i>}
                                    </Form.Group>
                                )}
                                {(brokerAccount.type === 'shoonya') && (
                                    <Form.Group className="mb-3 form-row" controlId="totpSecret">
                                        <Form.Label className="text-black">TOTP Secret Key</Form.Label>
                                        <Form.Control className="form-control-broker" type="text" placeholder="TOTP Secret Key" name="totpSecret" value={brokerAccount.totpSecret} onChange={onChange} />
                                        {brokerAccount.totpSecret && <i className="fa-solid fa-circle-check"></i>}
                                    </Form.Group>
                                )}
                                {(brokerAccount.type === 'kotakneo' || brokerAccount.type === 'angelone') && (
                                    <>
                                        {brokerAccount.type === 'kotakneo' && (
                                            <Form.Group className="mb-3 form-row" controlId="phoneNumber">
                                                <Form.Label className="text-black">Phone Number<span className="text-danger">*</span></Form.Label>
                                                <Form.Control className="form-control-broker" type="number" placeholder="Phone Number" name="phoneNumber" value={brokerAccount.phoneNumber} onChange={onChange} />
                                                {brokerAccount.phoneNumber && <i className="fa-solid fa-circle-check"></i>}
                                            </Form.Group>
                                        )}
                                        <Form.Group className="mb-3 form-row" controlId="mpin">
                                            <Form.Label className="text-black">MPIN<span className="text-danger">*</span></Form.Label>
                                            <Form.Control className="form-control-broker" type="number" placeholder="MPIN" name="mpin" value={brokerAccount.mpin} onChange={onChange} />
                                            {brokerAccount.mpin && <i className="fa-solid fa-circle-check"></i>}
                                        </Form.Group>
                                    </>
                                )}
                                <Button className="" variant="primary" type="submit" disabled={isSaveDisabled()}>
                                    Save API Configuration
                                </Button>
                                <Link to="/zerodha-config" target="_blank" className="d-none btn ml-2 btn-primary">
                                    How to configure Zerodha API step by step
                                </Link>
                            </Form>
                        </div>
                    </div>
                </Col>
                <Col md={8}>
                    {/* API Details Card */}
                    {(() => {
                        const brokerLinks = {
                            zerodha: { link: "https://developers.kite.trade/login", pathType: "zerodha" },
                            icici: { link: "https://api.icicidirect.com/apiuser/home", pathType: "icici" },
                            flattrade: { link: "https://wall.flattrade.in/", pathType: "flattrade" },
                            upstox: { link: "https://account.upstox.com/developer/apps", pathType: "upstox" },
                            shoonya: { link: "https://trade.shoonya.com/", pathType: "shoonya" },
                            kotakneo: { link: "https://trade.kotakneo.com/Login", pathType: "kotakneo" },
                            zebu: { link: "https://mynt.zebuetrade.com/", pathType: "zebu" },
                            dhan: { link: "https://login.dhan.co/?location=DH_WEB", pathType: "dhan" },
                            fyers: { link: "https://myapi.fyers.in/dashboard", pathType: "fyers" },
                            firstock: { link: "https://firstock.in/api/?ref=firstock.in", pathType: "firstock" },
                            '5paisa': { link: "https://xstream.5paisa.com/", pathType: "5paisa" },
                            angelone: { link: "https://smartapi.angelone.in/", pathType: "angelone" },
                            aliceblue: { link: "https://a3.aliceblueonline.com/myapps", pathType: "aliceblue" },
                            arrow: { link: "https://arrow.com/", pathType: "arrow" },
                            groww: { link: "https://groww.in/", pathType: "groww" },
                            xtsRetail: { link: "Check with broker for the details of API/Secret Key", pathType: "xts" },
                            xtsProp: { link: "Check with broker for the details of API/Secret Key", pathType: "xts" }
                        };
                        const currentBroker = brokerLinks[brokerAccount.type];
                        if (!currentBroker) return null;

                        const redirectUrl = brokerAccount.userName
                            ? `${tradeApiUrl}/v1/callback/${currentBroker.pathType}/${Base64.encode(brokerAccount.userName)}`
                            : '(Enter Client ID to generate URL)';

                        return (
                            <div className="card mb-3 api-details-card border-0 shadow-sm">
                                <div className="card-body">
                                    <h5 className="mb-3 d-flex align-items-center">
                                        API Configuration Details
                                    </h5>
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <label className="text-secondary small fw-bold d-block mb-1">API Key Generation Link</label>
                                            <div className="d-flex align-items-center">
                                                {currentBroker.link.startsWith('http') ? (
                                                    <a href={currentBroker.link} target="_blank" rel="noreferrer" className="text-decoration-none fw-medium text-truncate">
                                                        {currentBroker.link} <i className="fa fa-external-link ms-1 small"></i>
                                                    </a>
                                                ) : (
                                                    <span className="text-muted">{currentBroker.link}</span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={12} className={userIps?.length > 0 || brokerAccount.type === 'dhan' ? "mb-3" : ""}>
                                            <label className="text-secondary small fw-bold d-block mb-1">Redirect URL</label>
                                            <div style={{ width: 'fit-content' }} className="d-flex align-items-center bg-light p-2 rounded border">
                                                <code className="text-dark flex-grow-1 overflow-hidden text-truncate" style={{ fontSize: '0.85rem' }}>
                                                    {redirectUrl}
                                                </code>
                                                {brokerAccount.userName && (
                                                    <Button variant="text" className="p-0 ms-2 text-primary shadow-none" title="Copy URL" onClick={() => handleCopy(redirectUrl, 'Redirect URL Copied!')}>
                                                        <Copy size={16} />
                                                    </Button>
                                                )}
                                            </div>
                                        </Col>
                                        {(userIps?.length > 0 || brokerAccount.type === 'dhan') && (
                                            <Col md={12}>
                                                <label className="text-secondary small fw-bold d-block mb-1">Your Static IPs (for Whitelisting)</label>
                                                <div className="d-flex flex-wrap gap-2 mt-1">
                                                    {brokerAccount.type === 'dhan' && (
                                                        <div className="d-flex align-items-center bg-light px-2 py-1 rounded border" style={{ fontSize: '0.85rem' }}>
                                                            <Tag className="me-2" color="orange">Dhan Exclusive</Tag>
                                                            <code style={{ fontFamily: "monospace" }} className="text-dark fw-bold me-2">103.67.236.182</code>
                                                            <Button variant="text" className="p-0 text-primary shadow-none" onClick={() => handleCopy("103.67.236.182", "Dhan Exclusive IP Copied!")}>
                                                                <Copy size={14} />
                                                            </Button>
                                                        </div>
                                                    )}
                                                    {userIps?.map((ip, idx) => (
                                                        <div key={idx} className="d-flex align-items-center bg-light px-2 py-1 rounded border" style={{ fontSize: '0.85rem' }}>
                                                            <code style={{ fontFamily: "monospace" }} className="text-dark fw-bold me-2">{ip.ipAddress}</code>
                                                            <Button variant="link" className="p-0 text-primary shadow-none" onClick={() => handleCopy(ip.ipAddress, "IP Address Copied!")}>
                                                                <Copy size={14} />
                                                            </Button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                </div>
                            </div>
                        );
                    })()}

                    {brokerAccount.type === 'zerodha' && (
                        <div className="howtoconfig-wrap card">
                            <div className="card-body">
                                <div className="page-title">
                                    <h4>Step by step instructions to setup Zerodha broker account</h4>
                                </div>
                                <Collapse className="setup-steps" accordion defaultActiveKey={[defaultActiveKey]} onChange={onTabChange} activeKey={defaultActiveKey}>
                                    <Panel header="Step 1: Enter your 6-digit Zerodha Client ID" key="1">
                                        <p>Enter a unique name to identify this account, and your Zerodha Client ID to generate the Callback and Postback URLs.</p>
                                    </Panel>
                                    <Panel header="Step 2: Copy the URLs to be configured in next step." key="2">
                                        {brokerAccount.userName ? (
                                            <div className="coptToClipBoard">
                                                <p>
                                                    <label>Redirect URL:</label>
                                                    <span>{tradeApiUrl}/v1/callback/zerodha/{Base64.encode(brokerAccount.userName)}</span>
                                                    <Button type="Button" className="btn btn-sm btn-primary" onClick={() => handleCopy(`${tradeApiUrl}/v1/callback/zerodha/${Base64.encode(brokerAccount.userName)}`)}>{copySuccess}</Button>
                                                </p>
                                            </div>
                                        ) : (
                                            <p>Enter your Zerodha Client ID in Broker setup window to get the Callback and Postback URLs.</p>
                                        )}
                                    </Panel>
                                    <Panel header="Step 3: Sign up and login to developers.kite.trade." key="3">
                                        <a href="https://developers.kite.trade" target="_blank" rel="noreferrer">Click here to Sign up and Login to Kite Developer Portal for API creation</a>
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={zerodhaDevLoginImg} alt="Zerodha login" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 4: Click ‘Create new app’ to create a new API subscription." key="4">
                                        <div className="config-img">
                                            <img className="img-fluid" src={kiteAppCreateImg} alt="Kite app create" />
                                        </div>
                                        <div className="config-point">
                                            <ul>
                                                <li>Select app type ‘Connect’</li>
                                                <li>Enter any name to this App (For example, FNOTrader.com)</li>
                                                <li>Enter your Client ID</li>
                                                <li>Copy and paste the Redirect and Postback URLs from step 2 above</li>
                                                <li>Click ‘Create’ button to create the App</li>
                                            </ul>
                                        </div>
                                    </Panel>
                                    <Panel header="Step 5. After the successful creation of the app, go to ‘My Apps’ and click on the app name that you have created (FNOTrader.com)." key="5">
                                        <div className="config-img">
                                            <img className="img-fluid" src={AppSelectionImg} alt="App selection" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 6. You will see a screen with the API key and API secret. Copy the API Key and Secret Key from the App you created in step 5." key="6">
                                        <div className="config-img">
                                            <img className="img-fluid" src={AppSecrateKeyImg} alt="App secret key" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 7: Paste the API Key and Secret Key along with Zerodha Credentials." key="7">
                                        <p>Paste the API Key and Secret Key along with other details.</p>
                                    </Panel>
                                    <Panel header="Step 8: Setup Zerodha TOTP if you haven’t already. Find instructions to setup TOTP here: Zerodha TOTP Setup (Read below instructions fully before setting up TOTP)" key="8">
                                        <p>Note: For users who prefer to login automatically to all the configured zerodha accounts, whenever they login to FNOtrader.com, without entering their TOTP every time.</p>
                                        <p>Save the TOTP Secret you use to configure the external Authenticator App (Google authenticator/Microsoft authenticator/Authy app/etc). (screenshot on how to get TOTP secret shown below) and enter them in TOTP Secret Key field.</p>
                                        <p><a href="https://support.zerodha.com/category/your-zerodha-account/login-credentials/login-credentials-of-trading-platforms/articles/time-based-otp-setup" target="_blank" rel="noreferrer">Click here to view TOTP setup instructions.</a></p>
                                        <div className="config-img">
                                            <img className="img-fluid" src={AppTOTPSecrateKeyImg} alt="App TOTP secret" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 9: After entering all the details, Click 'Save Broker' button to finish the setup." key="9">
                                        <p>After entering all the details, Click 'Save Broker' button to finish the setup.</p>
                                    </Panel>
                                    <Panel header="Step 10: Login and test your account setup. You can enable any one account as your ‘Default’ account for trading." key="10">
                                        <Link to="/trading/broker-accounts" target="_blank" className="btn ml-2 btn-primary">
                                            Click here to login and test your account setup
                                        </Link>
                                    </Panel>
                                    <Panel header="Step 11: If you have entered ‘TOTP Secret Key’, then you have an option to enable/disable for Auto Login functionality. This will enable all your accounts to be logged in automatically when you login to our website FNOTrader.com." key="11">
                                        <p>If you have entered ‘TOTP Secret Key’, then you have an option to enable/disable for Auto Login functionality. This will enable all your accounts to be logged in automatically when you login to our website FNOTrader.com.</p>
                                    </Panel>
                                </Collapse>
                            </div>
                        </div>
                    )}
                    {brokerAccount.type === 'icici' && (
                        <div className="howtoconfig-wrap card">
                            <div className="card-body">
                                <div className="page-title">
                                    <h4>Step by step instructions to setup ICICI Direct broker account</h4>
                                </div>
                                <Collapse className="setup-steps" accordion defaultActiveKey={[defaultActiveKey]} onChange={onTabChange} activeKey={defaultActiveKey}>
                                    <Panel header="Step 1: Enter your ICICI Client ID" key="1">
                                        <p>Enter a unique name to identify this account, and your ICICI Client ID to generate the Callback and Postback URLs.</p>
                                    </Panel>
                                    <Panel header="Step 2: Copy the URLs to be configured in next step." key="2">
                                        {brokerAccount.userName ? (
                                            <div className="coptToClipBoard">
                                                <p>
                                                    <label>Redirect URL:</label>
                                                    <span>{tradeApiUrl}/v1/callback/icici/{Base64.encode(brokerAccount.userName)}</span>
                                                    <Button type="Button" className="btn btn-sm btn-primary" onClick={() => handleCopy(`${tradeApiUrl}/v1/callback/icici/${Base64.encode(brokerAccount.userName)}`)}>{copySuccess}</Button>
                                                </p>
                                            </div>
                                        ) : (
                                            <p>Enter your ICICI User ID in Broker setup window to get the Callback URL.</p>
                                        )}
                                    </Panel>
                                    <Panel header="Step 3: To start click on this link- https://api.icicidirect.com/apiuser/home" key="3">
                                        <p>To start click on this link- <a href="https://api.icicidirect.com/apiuser/home" target="_blank" rel="noreferrer">https://api.icicidirect.com/apiuser/home</a>.</p>
                                    </Panel>
                                    <Panel header="Step 4: Use ICICI Direct credentials to login." key="4">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={icicidirect1} alt="ICICI step 1" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 5: Click on Register an App." key="5">
                                        <div className="config-img">
                                            <img className="img-fluid" src={icicidirect2} alt="ICICI step 2" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 6. Fill below details and submit." key="6">
                                        <div className="config-img">
                                            <p>Fill below details and submit.</p>
                                            <p>App Name: <b>fnotrader.com</b></p>
                                            {brokerAccount.userName ? (
                                                <div className="coptToClipBoard">
                                                    <p>
                                                        <label>Redirect URL:</label>
                                                        <span>{tradeApiUrl}/v1/callback/icici/{Base64.encode(brokerAccount.userName)}</span>
                                                        <Button type="Button" className="btn btn-sm btn-primary" onClick={() => handleCopy(`${tradeApiUrl}/v1/callback/icici/${Base64.encode(brokerAccount.userName)}`)}>{copySuccess}</Button>
                                                    </p>
                                                </div>
                                            ) : (
                                                <p>Redirect URL: Enter your ICICI User ID in Broker setup window to get the Callback URL.</p>
                                            )}
                                            <div className="config-img">
                                                <img className="img-fluid" src={icicidirect3} alt="ICICI step 3" />
                                            </div>
                                        </div>
                                    </Panel>
                                    <Panel header="Step 7. Click View Apps." key="7">
                                        <div className="config-img">
                                            <img className="img-fluid" src={icicidirect4} alt="ICICI step 4" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 8: Click Deactive in App status." key="8">
                                        <div className="config-img">
                                            <img className="img-fluid" src={icicidirect5} alt="ICICI step 5" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 9: Click Yes button in confirmation popup and refresh the page." key="9">
                                        <div className="config-img">
                                            <img className="img-fluid" src={icicidirect6} alt="ICICI step 6" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 10: Now, please check your app status if it's Active, you can copy and paste API details in appropriate fields in the side window." key="10">
                                        <div className="config-img">
                                            <img className="img-fluid" src={icicidirect8} alt="ICICI step 8" />
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                        </div>
                    )}
                    {brokerAccount.type === 'upstox' && (
                        <div className="howtoconfig-wrap card">
                            <div className="card-body">
                                <div className="page-title">
                                    <h4>Step by Step Instruction to create and configure Upstox API.</h4>
                                </div>
                                <Collapse className="setup-steps" accordion defaultActiveKey={[defaultActiveKey]} onChange={onTabChange} activeKey={defaultActiveKey}>
                                    <Panel header="Step 1: Enter your Upstox Client ID" key="1">
                                        <p>Enter a unique name to identify this account, and your Upstox Client ID to generate the Callback and Postback URLs.</p>
                                    </Panel>
                                    <Panel header="Step 2: Copy the URLs to be configured in next step." key="2">
                                        {brokerAccount.userName ? (
                                            <div className="coptToClipBoard">
                                                <p>
                                                    <label>Redirect URL:</label>
                                                    <span>{tradeApiUrl}/v1/callback/upstox/{Base64.encode(brokerAccount.userName)}</span>
                                                    <Button type="Button" className="btn btn-sm btn-primary" onClick={() => handleCopy(`${tradeApiUrl}/v1/callback/upstox/${Base64.encode(brokerAccount.userName)}`)}>{copySuccess}</Button>
                                                </p>
                                            </div>
                                        ) : (
                                            <p>Enter your Upstox Client ID in Broker setup window to get the Callback URL.</p>
                                        )}
                                    </Panel>
                                    <Panel header="Step 3: To start click on this link- https://account.upstox.com/developer/apps" key="3">
                                        <p>Go to this link - <a href="https://account.upstox.com/developer/apps" target="_blank" rel="noreferrer">https://account.upstox.com/developer/apps</a> and authenticate yourself using your Upstox credentials.</p>
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={upstox1} alt="Upstox 1" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 4: Once you are successfully logged in, select the menu “Apps” and click “New App”." key="4">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={upstox2} alt="Upstox 2" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 5: Enter the App Name and copy, paste the Redirect URL and Postback URL. Click “CONTINUE” to create the app." key="5">
                                        <div className="config-img">
                                            <img className="img-fluid" src={upstox3} alt="Upstox 3" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 6: Copy and Paste the API Key and Secret Key to the FNOTrader screen." key="6">
                                        <div className="config-img">
                                            <img className="img-fluid" src={upstox4} alt="Upstox 4" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 7: Save the Configuration and in the next page, press the “Click here to Generate the token” link to login and generate the token." key="7">
                                        <p>Save the Configuration and in the next page, press the “Click here to Generate the token” link to login and generate the token.</p>
                                    </Panel>
                                </Collapse>
                                <p className="mt-2">Note: The token will be valid for the day and you will have to generate the token every day for real time analysis and trading.</p>
                            </div>
                        </div>
                    )}
                    {brokerAccount.type === 'flattrade' && (
                        <div className="howtoconfig-wrap card">
                            <div className="card-body">
                                <div className="page-title">
                                    <h4>Step by Step Instruction to create and configure FlatTrade API.</h4>
                                </div>
                                <Collapse className="setup-steps" accordion defaultActiveKey={[defaultActiveKey]} onChange={onTabChange} activeKey={defaultActiveKey}>
                                    <Panel header="Step 1: Enter your FlatTrade Client ID" key="1">
                                        <p>Enter a unique name to identify this account, and your FlatTrade Client ID to generate the Callback and Postback URLs.</p>
                                    </Panel>
                                    <Panel header="Step 2: Copy the URLs to be configured in next step." key="2">
                                        {brokerAccount.userName ? (
                                            <div className="coptToClipBoard">
                                                <p>
                                                    <label>Redirect URL:</label>
                                                    <span>{tradeApiUrl}/v1/callback/flattrade/{Base64.encode(brokerAccount.userName)}</span>
                                                    <Button type="Button" className="btn btn-sm btn-primary" onClick={() => handleCopy(`${tradeApiUrl}/v1/callback/flattrade/${Base64.encode(brokerAccount.userName)}`)}>{copySuccess}</Button>
                                                </p>
                                            </div>
                                        ) : (
                                            <p>Enter your FlatTrade Client ID in Broker setup window to get the Callback URL.</p>
                                        )}
                                    </Panel>
                                    <Panel header="Step 3: Go to this link - https://wall.flattrade.in/" key="3">
                                        <p>Go to this link - <a href="https://wall.flattrade.in/" target="_blank" rel="noreferrer">https://wall.flattrade.in/</a> and authenticate yourself using your Flattrade credentials.</p>
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={FlatTrade1} alt="FlatTrade 1" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 4: Once you are successfully logged in, click on the menu “Pi”." key="4">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={FlatTrade2} alt="FlatTrade 2" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 5: Click “CREATE NEW API KEY" key="5">
                                        <div className="config-img">
                                            <img className="img-fluid" src={FlatTrade3} alt="FlatTrade 3" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 6: Enter the App Name and copy and paste the Redirect URL and Postback URL. Click “CREATE” to create the app." key="6">
                                        <div className="config-img">
                                            <img className="img-fluid" src={FlatTrade4} alt="FlatTrade 4" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 7: Copy and Paste the API Key and Secret Key to the FNOTrader screen." key="7">
                                        <div className="config-img">
                                            <img className="img-fluid" src={FlatTrade5} alt="FlatTrade 5" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 8: Save the Configuration and press the “Click here to Generate the token” link to login and generate the token." key="8">
                                        <p>Save the Configuration and press the “Click here to Generate the token” link to login and generate the token.</p>
                                    </Panel>
                                </Collapse>
                                <p className="mt-2">Note: The token will be valid for the day and you will have to generate the token every day for real time analysis and trading.</p>
                            </div>
                        </div>
                    )}
                    {brokerAccount.type === 'shoonya' && (
                        <div className="howtoconfig-wrap card">
                            <div className="card-body">
                                <div className="page-title">
                                    <h4>Step by Step Instruction to create and configure Shoonya (Finvasia) API.</h4>
                                </div>
                                <Collapse className="setup-steps" accordion defaultActiveKey={[defaultActiveKey]} onChange={onTabChange} activeKey={defaultActiveKey}>
                                    <Panel header="Step 1: Enter your Shoonya Client ID" key="1">
                                        <p>Enter a unique name to identify this account, and your Shoonya Client ID to generate the Callback and Postback URLs.</p>
                                    </Panel>
                                    <Panel header="Step 2: Copy the URLs to be configured in next step." key="2">
                                        {brokerAccount.userName ? (
                                            <div className="coptToClipBoard">
                                                <p>
                                                    <label>Redirect URL:</label>
                                                    <span>{tradeApiUrl}/v1/callback/shoonya/{Base64.encode(brokerAccount.userName)}</span>
                                                    <Button type="Button" className="btn btn-sm btn-primary" onClick={() => handleCopy(`${tradeApiUrl}/v1/callback/shoonya/${Base64.encode(brokerAccount.userName)}`)}>{copySuccess}</Button>
                                                </p>
                                            </div>
                                        ) : (
                                            <p>Enter your Shoonya Client ID in Broker setup window to get the Callback URL.</p>
                                        )}
                                    </Panel>
                                    <Panel header="Step 3: Go to this link - https://prism.shoonya.com/api" key="3">
                                        <p>Go to this link - <a href="https://prism.shoonya.com/api" target="_blank" rel="noreferrer">https://prism.shoonya.com/api</a> and authenticate yourself using your Shoonya credentials.</p>
                                    </Panel>
                                    <Panel header="Step 4: Once you are successfully logged in, click on the Profile Icon and select “API Key”" key="4">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={Shoonya1} alt="Shoonya 1" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 5: Click on “Generate your API Key” button." key="5">
                                        <p>Click on “Generate your API Key” button.</p>
                                    </Panel>
                                    <Panel header="Step 6: Copy and paste the Vendor Code and API Key to the FNOTrader.com screen." key="6">
                                        <div className="config-img">
                                            <img className="img-fluid" src={Shoonya2} alt="Shoonya 2" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 7: Password and TOTP Secret Key are optional fields. You can enter them every time you login." key="7">
                                        <p>Password and TOTP Secret Key are optional fields. You can enter them every time you login.</p>
                                    </Panel>
                                    <Panel header="Step 8: Save the Broker Configuration and in the next page, press the “Click here to Generate the token” link to login by providing the password and OTP/TOTP and generate the token." key="8">
                                        <p>Save the Broker Configuration and in the next page, press the “Click here to Generate the token” link to login by providing the password and OTP/TOTP and generate the token.</p>
                                    </Panel>
                                </Collapse>
                                <p className="mt-2">Note: The token will be valid for the day and you will have to generate the token every day for real time analysis and trading.</p>
                            </div>
                        </div>
                    )}
                    {brokerAccount.type === 'zebu' && (
                        <div className="howtoconfig-wrap card">
                            <div className="card-body">
                                <div className="page-title">
                                    <h4>Step by Step Instruction to create and configure Zebu API.</h4>
                                </div>
                                <Collapse className="setup-steps" accordion defaultActiveKey={[defaultActiveKey]} onChange={onTabChange} activeKey={defaultActiveKey}>
                                    <Panel header="Step 1: Enter your Zebu Client ID" key="1">
                                        <p>Enter a unique name to identify this account, and your Zebu Client ID to generate the Callback URL.</p>
                                    </Panel>
                                    <Panel header="Step 2: Copy the URLs to be configured in next step." key="2">
                                        {brokerAccount.userName ? (
                                            <div className="coptToClipBoard">
                                                <p>
                                                    <label>Redirect URL:</label>
                                                    <span>{tradeApiUrl}/v1/callback/zebu/{Base64.encode(brokerAccount.userName)}</span>
                                                    <Button type="Button" className="btn btn-sm btn-primary" onClick={() => handleCopy(`${tradeApiUrl}/v1/callback/zebu/${Base64.encode(brokerAccount.userName)}`)}>{copySuccess}</Button>
                                                </p>
                                            </div>
                                        ) : (
                                            <p>Enter your Zebu Client ID in Broker setup window to get the Callback URL.</p>
                                        )}
                                    </Panel>
                                    <Panel header="Step 3: Login to Zebu Mynt Portal using this link https://go.mynt.in/" key="3">
                                        <p>Login to Zebu Mynt Portal using this link <a href="https://go.mynt.in/" target="_blank" rel="noreferrer">https://go.mynt.in/</a>.</p>
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={zebu1} alt="Zebu step 3" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 4: Once you login, click on the Account ID to open the Profile" key="4">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={zebu2} alt="Zebu step 4" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 5: Click on the API Key button" key="5">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={zebu3} alt="Zebu step 5" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 6: Copy the Redirect URL from QuikTrade and paste it here, Enter the Static IP and Click Update button." key="6">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={zebu4} alt="Zebu step 6" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 7: Copy the Secret Code and Paste it in QuikTrade Broker Configuration Screen." key="7">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={zebu5} alt="Zebu step 7" />
                                        </div>
                                    </Panel>
                                    <Panel header="Step 8: Save the broker API configuration in Quiktrade." key="8">
                                        <div className="config-img">
                                            <img className="img-fluid response-image" src={zebu6} alt="Zebu step 8" />
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                        </div>
                    )}
                </Col>

            </Row>
        </>
    );
};

export default BrokerSetup;